import classNames from "classnames";
import styles from "./RelatedContent.module.css";
import { PictureOrVideo } from "components/atoms";
import classnames from "classnames";
import { useDeviceClassification } from "utils";
import { RelatedContentCard } from "../RelatedContentCard";

type ContentPieceProps = {
  MenuTitle: string;
  Abstract: string;
  Url: string;
  LargeBlockImage: { Alt: string; Src: string };
  HeroSectionImage1: { Alt: string; Src: string };
};

export interface RelatedContentProps {
  className?: string;
  content: ContentPieceProps[];
  heading?: string;
  abstracts?: boolean;
}

export const RelatedContent = ({
  className = "",
  content,
  heading,
  abstracts = false,
  ...props
}: RelatedContentProps) => {
  const relatedItems = content.slice(0, 3);
  const { isDesktop } = useDeviceClassification();

  return (
    <div id="related-content" className={classNames(styles.relatedcontent, className)} {...props}>
      {heading && <h2>{heading}</h2>}

      <div className={styles.itemsWrapper}>
        {relatedItems &&
          relatedItems.map(({ MenuTitle, Abstract, Url, LargeBlockImage, HeroSectionImage1 }, i) => (
            <RelatedContentCard
              key={MenuTitle + i}
              id={MenuTitle + i}
              index={i}
              Title={MenuTitle}
              isDesktop={isDesktop}
              Url={Url}
              LargeBlockImage={LargeBlockImage}
              HeroSectionImage1={HeroSectionImage1}
              Abstract={Abstract}
              Abstracts={abstracts}
            />
          ))}
      </div>
    </div>
  );
};
